import reducer from './reducers'
import {createStore} from 'redux'

export const store = createStore(reducer)


// WEBPACK FOOTER //
// ./src/redux/store.js